'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _LabelledToggleSwitch = require('../elements/LabelledToggleSwitch');

var _LabelledToggleSwitch2 = _interopRequireDefault(_LabelledToggleSwitch);

var _WidgetUtils = require('../../../utils/WidgetUtils');

var _WidgetUtils2 = _interopRequireDefault(_WidgetUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WidgetOpenIDPermissionsDialog = function (_React$Component) {
    (0, _inherits3.default)(WidgetOpenIDPermissionsDialog, _React$Component);

    function WidgetOpenIDPermissionsDialog() {
        (0, _classCallCheck3.default)(this, WidgetOpenIDPermissionsDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WidgetOpenIDPermissionsDialog.__proto__ || (0, _getPrototypeOf2.default)(WidgetOpenIDPermissionsDialog)).call(this));

        _this._onAllow = function () {
            _this._onPermissionSelection(true);
        };

        _this._onDeny = function () {
            _this._onPermissionSelection(false);
        };

        _this._onRememberSelectionChange = function (newVal) {
            _this.setState({ rememberSelection: newVal });
        };

        _this.state = {
            rememberSelection: false
        };
        return _this;
    }

    (0, _createClass3.default)(WidgetOpenIDPermissionsDialog, [{
        key: '_onPermissionSelection',
        value: function _onPermissionSelection(allowed) {
            if (this.state.rememberSelection) {
                console.log('Remembering ' + this.props.widgetId + ' as allowed=' + allowed + ' for OpenID');

                var currentValues = _SettingsStore2.default.getValue("widgetOpenIDPermissions");
                if (!currentValues.allow) currentValues.allow = [];
                if (!currentValues.deny) currentValues.deny = [];

                var securityKey = _WidgetUtils2.default.getWidgetSecurityKey(this.props.widgetId, this.props.widgetUrl, this.props.isUserWidget);
                (allowed ? currentValues.allow : currentValues.deny).push(securityKey);
                _SettingsStore2.default.setValue("widgetOpenIDPermissions", null, _SettingsStore.SettingLevel.DEVICE, currentValues);
            }

            this.props.onFinished(allowed);
        }
    }, {
        key: 'render',
        value: function render() {
            var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
            var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');

            return _react2.default.createElement(
                BaseDialog,
                { className: 'mx_WidgetOpenIDPermissionsDialog', hasCancel: true,
                    onFinished: this.props.onFinished,
                    title: (0, _languageHandler._t)("A widget would like to verify your identity") },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_WidgetOpenIDPermissionsDialog_content' },
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _languageHandler._t)("A widget located at %(widgetUrl)s would like to verify your identity. " + "By allowing this, the widget will be able to verify your user ID, but not " + "perform actions as you.", {
                            widgetUrl: this.props.widgetUrl
                        })
                    ),
                    _react2.default.createElement(_LabelledToggleSwitch2.default, { value: this.state.rememberSelection, toggleInFront: true,
                        onChange: this._onRememberSelectionChange,
                        label: (0, _languageHandler._t)("Remember my selection for this widget") })
                ),
                _react2.default.createElement(DialogButtons, {
                    primaryButton: (0, _languageHandler._t)("Allow"),
                    onPrimaryButtonClick: this._onAllow,
                    cancelButton: (0, _languageHandler._t)("Deny"),
                    onCancel: this._onDeny
                })
            );
        }
    }]);
    return WidgetOpenIDPermissionsDialog;
}(_react2.default.Component); /*
                              Copyright 2019 Travis Ralston
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

WidgetOpenIDPermissionsDialog.propTypes = {
    onFinished: _propTypes2.default.func.isRequired,
    widgetUrl: _propTypes2.default.string.isRequired,
    widgetId: _propTypes2.default.string.isRequired,
    isUserWidget: _propTypes2.default.bool.isRequired
};
exports.default = WidgetOpenIDPermissionsDialog;
module.exports = exports['default'];
//# sourceMappingURL=WidgetOpenIDPermissionsDialog.js.map